import React from "react";
import { Separator } from "./ui/separator";
import { Phone, Mail } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-12">
          {/* Company Info */}
          <div className="space-y-8">
            <div className="flex items-center space-x-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_energy-deals-2/artifacts/gkvjik01_easy_power_logo_rolex_white_friendly_font%20copie.png"
                alt="EASY POWER Logo"
                className="h-16 w-auto"
              />
            </div>
            
            <p className="text-gray-400 leading-relaxed text-lg">
              Spécialisé dans l'optimisation énergétique, nous aidons entreprises et particuliers 
              à réduire leurs factures d'électricité et de gaz grâce à des contrats sur-mesure.
            </p>

            <div className="space-y-4">
              <div className="flex items-center space-x-4">
                <Phone className="h-5 w-5 text-blue-400" />
                <a href="tel:0465848305" className="text-gray-300 hover:text-white transition-colors text-lg">
                  04 65 84 83 05
                </a>
              </div>
              <div className="flex items-center space-x-4">
                <Mail className="h-5 w-5 text-green-400" />
                <a href="mailto:contact@easy-power.fr" className="text-gray-300 hover:text-white transition-colors text-lg">
                  contact@easy-power.fr
                </a>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-2xl font-semibold mb-8">Nos Services</h4>
            <ul className="space-y-4">
              <li>
                <button
                  onClick={() => scrollToSection("#services")}
                  className="text-gray-400 hover:text-white transition-colors text-left text-lg"
                >
                  Négociation de contrats
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("#services")}
                  className="text-gray-400 hover:text-white transition-colors text-left text-lg"
                >
                  Audit énergétique
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("#services")}
                  className="text-gray-400 hover:text-white transition-colors text-left text-lg"
                >
                  Transition énergétique
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("#services")}
                  className="text-gray-400 hover:text-white transition-colors text-left text-lg"
                >
                  Optimisation des aides CEE
                </button>
              </li>
            </ul>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-2xl font-semibold mb-8">Navigation</h4>
            <ul className="space-y-4">
              <li>
                <button
                  onClick={() => scrollToSection("#home")}
                  className="text-gray-400 hover:text-white transition-colors text-left text-lg"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("#calculator")}
                  className="text-gray-400 hover:text-white transition-colors text-left text-lg"
                >
                  Calculateur d'économies
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("#testimonials")}
                  className="text-gray-400 hover:text-white transition-colors text-left text-lg"
                >
                  Témoignages
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("#faq")}
                  className="text-gray-400 hover:text-white transition-colors text-left text-lg"
                >
                  FAQ
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("#contact")}
                  className="text-gray-400 hover:text-white transition-colors text-left text-lg"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Legal & Contact */}
          <div>
            <h4 className="text-2xl font-semibold mb-8">Informations légales</h4>
            <div className="space-y-4 text-gray-400">
              <p className="text-lg">
                <strong className="text-white">EASY POWER</strong><br />
                SARL unipersonnelle au capital social de 92 640,00 €
              </p>
              <p className="text-lg">
                N° SIREN : 393.295.811<br />
                N° TVA : FR09393295811
              </p>
              <div className="space-y-3 mt-6">
                <button className="block text-gray-400 hover:text-white transition-colors text-left text-lg">
                  Mentions légales
                </button>
                <button className="block text-gray-400 hover:text-white transition-colors text-left text-lg">
                  CGV
                </button>
                <button className="block text-gray-400 hover:text-white transition-colors text-left text-lg">
                  Politique de confidentialité
                </button>
                <button className="block text-gray-400 hover:text-white transition-colors text-left text-lg">
                  Plan du site
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Separator className="bg-gray-700" />

      {/* Bottom Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center space-y-6 md:space-y-0">
          <div className="text-gray-400 text-lg">
            © {currentYear} EASY POWER. Tous droits réservés.
          </div>
          
          <div className="text-gray-400 text-center md:text-right">
            <div className="text-lg">Courtage en énergie - Spécialiste des économies d'électricité et gaz</div>
            <div className="mt-2 text-lg">🌱 Contribuez à la transition énergétique avec EASY POWER</div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;